import React, { useContext } from 'react'
// NAVIGATION
import { useNavigate } from 'react-router-dom'
// IMAGES
import imageCalendar from '../../../images/calendargif.gif'
import imageSiteWeb from '../../../images/imagesiteweb.png'
import imageServices from '../../../images/service.png'
import imagePush from '../../../images/imagepush.png'
import imageProfil from '../../../images/imageprofil.png'
import imageForfait from '../../../images/imageforfait.png'
import imageChat from '../../../images/chat.png'
import imageChatGif from '../../../images/chatgif.gif'
import imageClients from '../../../images/clients.png'
import imageStaff from '../../../images/staff.png'
// CONTEXT
import { AppContext } from '../../../App'

const ButtonsHome = ({ profil, messagesChat }) => {
    let navigate = useNavigate()
    const { user } = useContext(AppContext)

    return (
        <div>

            {/* CARD PLANNING */}
            <div className='mt-3' onClick={() => navigate('/planning')}>
                <div className='card-body bg-white shadow rounded-2'>
                    <div className='text-center'>
                        <img src={imageCalendar} className='img-fluid' alt='image calendar' style={{ height:50, width:50 }} />
                        <div className='text-center' style={{fontSize:12}}>PLANNING</div>
                    </div>
                </div>
            </div>

            {/* AFFICHAGE BOUTONS PANNING / CLIENTS */} 
            <div className='row text-center mt-4'>

                {/* CLIENTS */}
                <div className='col-6' onClick={() => navigate('/clients')}>
                    <div className='bg-white shadow rounded-2 py-3' style={{ marginLeft:-3}}>
                        <div className='text-center'>
                            <img src={imageClients} className='img-fluid' alt='image clients' style={{ height:50, width:50 }} />
                            <div className='text-center' style={{fontSize:12}}>CLIENTS</div>
                        </div>
                    </div>
                </div>

                {/* SITE WEB */}
                <div className='col-6' onClick={() => navigate('/siteWeb')}>
                    <div className='bg-white shadow rounded-2 py-3' style={{ marginRight:-3}}>
                        <div className='text-center'>
                            <img src={imageSiteWeb} className='img-fluid' alt='image site web' style={{ height:50, width:50 }} />
                            <div className='text-center' style={{fontSize:12}}>SITE WEB</div>
                        </div>
                    </div>
                </div>

            </div>

            {/* AFFICHAGE BOUTONS SERVICES / EQUIPE */} 
            <div className='row text-center mt-4'>

                {/* EQUIPE */}
                <div className='col-6' onClick={() => navigate('/staff')}>
                    <div className='bg-white shadow rounded-2 py-3' style={{ marginLeft:-3}}>
                        <div className='text-center'>
                            <img src={imageStaff} className='img-fluid' alt='image staff' style={{ height:50, width:50 }} />
                            <div className='text-center' style={{fontSize:12}}>EQUIPE</div>
                        </div>
                    </div>
                </div>

                {/* SERVICES */}
                <div className='col-6' onClick={() => navigate('/services')}>
                    <div className='bg-white shadow rounded-2 py-3' style={{ marginRight:-3}}>
                        <div className='text-center'>
                            <img src={imageServices} className='img-fluid' alt='image services' style={{ height:50, width:50 }} />
                            <div className='text-center' style={{fontSize:12}}>SERVICES</div>
                        </div>
                    </div>
                </div>

            </div>

            {/* AFFICHAGE BOUTONS SITE WEB / MESSAGE PUSH */} 
            <div className='row text-center mt-4'> 

                {/* MESSAGE PUSH */}
                <div className='col-6' onClick={() => navigate('/messagePush')}>
                    <div className='bg-white shadow rounded-2 py-3' style={{ marginLeft:-3}}>
                        <div className='text-center'>
                            <img src={imagePush} className='img-fluid' alt='image message push' style={{ height:50, width:50 }} />
                            <div className='text-center' style={{fontSize:12}}>MESSAGE PUSH</div>
                        </div>
                    </div>
                </div>

                {/* CHAT */}
                <div className='col-6' onClick={() => navigate('/chat')}>
                    <div className='bg-white shadow rounded-2 py-3' style={{ marginLeft:-3}}>
                        <div className='text-center'>
                                    {/* TEST IS NEW CHAT*/}
                                {messagesChat
                                    .filter(mes => mes.receiver === 'administrateur' && mes.isNew)
                                    .map(mes => mes.id).length != 0 ? 
                                        <img src={imageChatGif} className='img-fluid' alt='image message' style={{ height:50, width:50 }} />
                                    : 
                                        <img src={imageChat} className='img-fluid' alt='image message' style={{ height:50, width:50 }} />
                                    }
                            
                            <div className='text-center' style={{fontSize:12}}>CHAT</div>
                        </div>
                    </div> 
                </div>

            </div>

            {/* AFFICHAGE BOUTONS PROFIL / FORFAIT */} 
            <div className='row text-center mt-4'>

                {/* PROFIL */}
                <div className='col-6' onClick={() => navigate('/profil')}>
                    <div className='bg-white shadow rounded-2 py-3' style={{ marginRight:-3}}>
                        <div className='text-center'>
                            <img src={imageProfil} className='img-fluid' alt='image profil' style={{ height:50, width:50 }} />
                            <div className='text-center' style={{fontSize:12}}>PROFIL</div>
                        </div>
                    </div>
                </div>

                {/* FORFAIT */}
                <div className='col-6' onClick={() => navigate('/forfait')}>
                    <div className='bg-white shadow rounded-2 py-3' style={{ marginLeft:-3}}>
                        <div className='text-center'>
                            <img src={imageForfait} className='img-fluid' alt='image forfait' style={{ height:50, width:50 }} />
                            <div className='text-center' style={{fontSize:12}}>FORFAIT</div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    )
}

export default ButtonsHome


